export default "__VITE_ASSET__VS8VcCSIW7MLYj6GBLhpww__"